export const USER_DEFAULT_TYPE = 1
export const USER_VEHICLE_TYPE = 2
export const USER_GOODS_AND_SERVICES = 3

export default {
  USER_DEFAULT_TYPE,
  USER_VEHICLE_TYPE,
  USER_GOODS_AND_SERVICES
}
